import { easeSnappy, durMedium } from './easings.js';
import { prefersReducedMotion } from './prefersReducedMotion.js';

const STAGGER = 0.08;
const ROW_TOLERANCE = 4;

// Walk up from the popInView element until we find an ancestor whose siblings
// each contain a popInView descendant. This treats `<swiper-slide>` wrappers
// (product-shelf) and the article itself (product-grid) uniformly.
function findPeerWrapper(el) {
  let current = el;
  while (current.parentElement && current.parentElement !== document.body) {
    const parent = current.parentElement;
    const peers = Array.from(parent.children).filter(
      (c) => c === current || c.querySelector('[x-data*="popInView"]'),
    );
    if (peers.length >= 2) return { wrapper: current, peers };
    current = parent;
  }
  return null;
}

function columnIndex(el) {
  const found = findPeerWrapper(el);
  if (!found) return 0;
  const { wrapper, peers } = found;
  const top = wrapper.getBoundingClientRect().top;
  const sameRow = peers
    .map((p) => ({ el: p, rect: p.getBoundingClientRect() }))
    .filter((p) => Math.abs(p.rect.top - top) <= ROW_TOLERANCE)
    .sort((a, b) => a.rect.left - b.rect.left);
  return Math.max(0, sameRow.findIndex((p) => p.el === wrapper));
}

/** scale + opacity entrance gated by viewport enter; row-mates stagger by column.
 *  The CSS in `modules/_all.scss` pre-hides the element to prevent FOUC; we
 *  animate explicitly to the visible state when the trigger fires. */
export default () => ({
  init() {
    const el = this.$el;
    if (prefersReducedMotion()) {
      window.gsap.set(el, { opacity: 1, scale: 1, clearProps: 'opacity,visibility,transform,willChange' });
      return;
    }
    const delay = columnIndex(el) * STAGGER;
    // autoAlpha (opacity + visibility) so the pre-hidden element carries
    // `visibility: hidden` and contrast checkers skip it rather than flagging
    // low-contrast text at opacity 0.
    window.gsap.set(el, { autoAlpha: 0, scale: 0.96 });
    window.gsap.to(el, {
      scale: 1,
      autoAlpha: 1,
      duration: durMedium,
      ease: easeSnappy,
      delay,
      scrollTrigger: { trigger: el, start: 'top 85%', once: true },
    });
  },
});
